export const LEADS_SQL = `
SELECT
  external_id,
  name,
  email,
  firm,
  advice_type,
  licensee,
  conference,
  note,
  team_member,
  country_code,
  created_date_utc
FROM reporting.lead_form
ORDER BY created_date_utc DESC
`;
